import {useEffect, useRef, useState} from 'react';

type UseInViewOptions = IntersectionObserverInit & {
  triggerOnce?: boolean;
};

export const useInView = (options?: UseInViewOptions) => {
  const {triggerOnce = false, ...observerOptions} = options || {};
  const ref = useRef<HTMLDivElement | null>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        if (triggerOnce) {
          observer.disconnect();
        }
      } else if (!triggerOnce) {
        setIsInView(false);
      }
    }, observerOptions);

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [ref.current, observerOptions, triggerOnce]);

  return {ref, isInView};
};
